export let FundingSourceActivationStatusEnum = /*#__PURE__*/function (FundingSourceActivationStatusEnum) {
  FundingSourceActivationStatusEnum["Active"] = "active";
  FundingSourceActivationStatusEnum["Inactive"] = "inactive";
  return FundingSourceActivationStatusEnum;
}({});
export let RelationshipFundingSourceType = /*#__PURE__*/function (RelationshipFundingSourceType) {
  RelationshipFundingSourceType["CreditCard"] = "creditCard";
  RelationshipFundingSourceType["Ach"] = "ach";
  return RelationshipFundingSourceType;
}({});